// extracted by mini-css-extract-plugin
module.exports = {"root":"basic-hero_root___EKl4 shared_center__Tn2Ei","imageOverlay":"basic-hero_imageOverlay___1URZ","imageClip":"basic-hero_imageClip__uIjzX","heading":"basic-hero_heading__sjXLS"};